import { Control } from 'react-hook-form';
import { IApplyNowReferrerInformationForm, ApplyNowFormValues } from '../../../../common';
import { Grid, FormInputText, FormTextArea, Typography } from '../../../../base';
import CandidateForm from '../../../CandidateForm';
import { useTranslation } from 'react-i18next';

interface ReferrerInformationStepProps {
    control: Control<IApplyNowReferrerInformationForm>;
}

const ReferrerInformationStep = (props: ReferrerInformationStepProps) => {
    const { control } = props;
    const { t } = useTranslation();

    return (
        <Grid container spacing={1} minHeight="min-content" width="100%">
            <Grid item xs={12} pb={1}>
                <Typography variant="body1">{t('applyNow.referrerInfoTitle')}</Typography>
            </Grid>
            <CandidateForm
                control={control}
                name={ApplyNowFormValues.referrerName}
                lastName={ApplyNowFormValues.referrerLastName}
                phoneNumber={ApplyNowFormValues.referrerPhoneNumber}
                email={ApplyNowFormValues.referrerEmail}
            />
            <Grid item xs={12} pt={1.4}>
                <FormInputText
                    name={ApplyNowFormValues.referrerCompany}
                    control={control}
                    label={t('applyNow.referrerCompany')}
                    required
                />
            </Grid>
            <Grid item xs={12}>
                <FormTextArea
                    name={ApplyNowFormValues.coverLetter}
                    control={control}
                    label={t('applyNow.additionalInformation')}
                    rows={4}
                />
            </Grid>
        </Grid>
    );
};

export default ReferrerInformationStep;
